const withExactTotal = (shares: number[], newTotal: number): number[] => {
  if (shares.length === 0) {
    return [];
  }

  const allocatedExceptLast = shares.slice(0, -1).reduce((total, share) => total + share, 0);

  return [...shares.slice(0, -1), newTotal - allocatedExceptLast];
};

export const distributeTimeProRata = ({
  currentTimes,
  newTotal,
}: {
  currentTimes: Array<number | null>;
  newTotal: number;
}): number[] => {
  const times = currentTimes.map((time) => time ?? 0);
  if (times.length === 0) {
    return [];
  }

  const currentTotal = times.reduce((total, time) => total + time, 0);
  if (currentTotal === 0) {
    const share = newTotal / times.length;

    return withExactTotal(
      times.map(() => share),
      newTotal,
    );
  }

  return withExactTotal(
    times.map((time) => (time / currentTotal) * newTotal),
    newTotal,
  );
};
